import Loadable from 'react-loadable';

import { CustomLoadableLoading } from '../../components/loading/loading.js';

const HomePageAsync = Loadable({
	loader: () => import(/* webpackChunkName: "home-page" */ './home.page.js'),
	modules: ['./home.page.js'],
	webpack: () => [require.resolveWeak('./home.page.js')],
	loading: CustomLoadableLoading,
});

export default HomePageAsync;
